export enum SystemModulesEnum {
  Contracts = -1,
  ChangeOrder = -2,
  ProgressPayment = -3,
  SOV = -4,
  SOVI = -5,
  PaymentPeriod = -6,
  Users = -7,
  Roles = -9,
  Projects = -10,
  Correspondence = -11,
  Modules = -12,
  CompanyProfile = -13,
  Menu = -14,
  Organizations = -15,
  Dashboard = -16,
  Schedules = -17,
  FinancialSchedules = -18,
  Holidays = -19,
  FileContractManager = -20,
  MyCIPODrive = -21,
  Contacts = -22,
  Programs = -23,
  ListsManagement = -25,
  TenantSettings = -26,
  PDFMarkup = -27,
  Maps = -28,
  SysAdmin = -29,
}
